/**
 * spa-back-scroll.ts — восстановление scrollY каталога после «Назад» со страницы товара
 */

const SPA_SCROLL_KEY = 'torgirt-sf-spa-scroll-v1';
const SPA_MAX_AGE_MS = 30000;
const MAX_ENTRIES = 8;
const SCROLL_Y_TOLERANCE = 8;

interface SpaScrollEntry {
  path: string;
  search: string;
  y: number;
  t: number;
}

function loadStack(): SpaScrollEntry[] {
  try {
    const raw = sessionStorage.getItem(SPA_SCROLL_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    return Array.isArray(parsed) ? (parsed as SpaScrollEntry[]) : [];
  } catch {
    return [];
  }
}

function saveStack(stack: SpaScrollEntry[]): void {
  try {
    sessionStorage.setItem(SPA_SCROLL_KEY, JSON.stringify(stack.slice(-MAX_ENTRIES)));
  } catch {
    /* ignore */
  }
}

function maxScrollY(): number {
  return Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
}

export function rememberSpaProductScroll(): void {
  const entry: SpaScrollEntry = {
    path: location.pathname,
    search: location.search,
    y: window.scrollY,
    t: Date.now(),
  };
  const stack = loadStack();
  stack.push(entry);
  saveStack(stack);
}

export function restoreSpaProductScroll(): void {
  const stack = loadStack();
  if (!stack.length) return;

  const now = Date.now();
  let matchIndex = -1;
  for (let i = stack.length - 1; i >= 0; i--) {
    const e = stack[i];
    if (now - e.t > SPA_MAX_AGE_MS) continue;
    if (e.path === location.pathname && e.search === location.search) {
      matchIndex = i;
      break;
    }
  }
  if (matchIndex < 0) return;

  const saved = stack[matchIndex];
  stack.splice(matchIndex, 1);
  saveStack(stack);

  const target = Math.min(Math.max(0, saved.y), maxScrollY());

  const apply = (): void => {
    if (Math.abs(window.scrollY - target) > SCROLL_Y_TOLERANCE) {
      window.scrollTo(0, target);
    }
  };

  apply();
  requestAnimationFrame(() => {
    requestAnimationFrame(apply);
  });
}
